import * as api from '../_utils/api';

export class StatisticsApi {

    static async getStatistics(type: string, numberOfDays: number, showInactiveUsers = false): Promise<any> {
        return api._get(`common/statistics/${type}?days=${numberOfDays}&active=${showInactiveUsers}`);
    }
}
